(function() {
	function SoundDictionary() 
	{	
		if (!cm.soundDictionary) 
		{
			cm.soundDictionary = this;
		}
	}

	var p = SoundDictionary.prototype;

	p._dictionary = {};

	p.getSoundID = function(alias) 
	{

		if (alias instanceof Array) 
		{

			var list = [];
			for (var i = 0, l = alias.length; i < l; i++) 
			{	
				list[i] = this._dictionary[alias[i]].file;
			}
			return list;

		} 
		else 
		{
			return this._dictionary[alias].file;
		}
	};


	p.addFromOldXML = function(xml) 
	{	
		// The music and sfx files all have pretty unique names,
		// So I'm only going to make aliases for the VO files.
		var sounds = xml.getElementsByTagName('vo')[0].childNodes;
		for (var i = 0, l = sounds.length; i < l; i++) {
			if (sounds[i].tagName === 'sound')
			{
				this._dictionary[sounds[i].getAttribute('id')] = {
					file: sounds[i].getAttribute('file')
				};
			}
		}
	};

	p.addFromOldJSON = function(config) 
	{
		var sounds = config;

		for (var i = 0, l = sounds.length; i < l; i++) {
			this._dictionary[sounds[i].id] = {
				file: sounds[i].file
			};
		}
	};

	new SoundDictionary();

})();